module.exports = __webpack_public_path__ + "img/illustration.327ffa1c.png";